/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-param-reassign */
import React, { useCallback, useEffect, useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import PropTypes from 'prop-types';

const SignaturePad = ({
  activeColor,
  strokeSize,
  newDrawSnapshotHandler,
  canvasRef,
  drawType,
}) => {
  const canvasElement = useRef(null);
  const context = useRef(null);
  const startPosition = useRef({ x: 0, y: 0 });
  const lineCoordinates = useRef({ x: 0, y: 0 });

  const getClientOffset = (event) => {
    const can = canvasRef.current.getCanvas().getBoundingClientRect();
    const { pageX, pageY } = event.touches ? event.touches[0] : event;
    const x = pageX - can.left;
    const y = pageY - can.top;

    return {
      x,
      y,
    };
  };
  const drawLine = () => {
    const headlen = 20;
    const angle = Math.atan2(
      lineCoordinates.current.y - startPosition.current.y,
      lineCoordinates.current.x - startPosition.current.x
    );
    context.current.beginPath();
    context.current.lineWidth = 5;
    context.current.lineCap = 'round';
    context.current.strokeStyle = activeColor;

    context.current.moveTo(startPosition.current.x, startPosition.current.y);
    context.current.lineTo(
      lineCoordinates.current.x,
      lineCoordinates.current.y
    );
    context.current.moveTo(
      lineCoordinates.current.x,
      lineCoordinates.current.y
    );
    context.current.lineTo(
      lineCoordinates.current.x - headlen * Math.cos(angle - Math.PI / 6),
      lineCoordinates.current.y - headlen * Math.sin(angle - Math.PI / 6)
    );

    context.current.moveTo(
      lineCoordinates.current.x,
      lineCoordinates.current.y
    );
    context.current.lineTo(
      lineCoordinates.current.x - headlen * Math.cos(angle + Math.PI / 6),
      lineCoordinates.current.y - headlen * Math.sin(angle + Math.PI / 6)
    );

    context.current.closePath();
    context.current.stroke();
  };

  const mouseDownListener = (event) => {
    startPosition.current = getClientOffset(event);
  };

  const mouseupListener = (event) => {
    lineCoordinates.current = getClientOffset(event);
    drawLine();
    newDrawSnapshotHandler();
  };

  useEffect(() => {
    if (canvasRef && canvasRef.current) {
      canvasElement.current = canvasRef.current.getCanvas();
      context.current = canvasRef.current.getCanvas().getContext('2d');

      if (drawType === 'arrow') {
        canvasElement.current.addEventListener('mousedown', mouseDownListener);
        canvasElement.current.addEventListener('mouseup', mouseupListener);
        canvasRef.current.off();
      } else {
        canvasElement.current.removeEventListener(
          'mousedown',
          mouseDownListener
        );
        canvasElement.current.removeEventListener('mouseup', mouseupListener);
        canvasElement.current.removeEventListener(
          'touchstart',
          mouseDownListener
        );
        canvasElement.current.removeEventListener('touchend', mouseupListener);
        canvasRef.current.on();
      }
    }

    return () => {
      canvasElement.current.removeEventListener('mousedown', mouseDownListener);
      canvasElement.current.removeEventListener('mouseup', mouseupListener);
    };
  }, [drawType, newDrawSnapshotHandler, activeColor]);

  return (
    <>
      <SignatureCanvas
        penColor={activeColor}
        ref={(ref) => {
          canvasRef.current = ref;
        }}
        onEnd={newDrawSnapshotHandler}
        clearOnResize={false}
        maxWidth={strokeSize}
      />
    </>
  );
};

SignaturePad.propTypes = {
  activeColor: PropTypes.string.isRequired,
  strokeSize: PropTypes.number.isRequired,
  newDrawSnapshotHandler: PropTypes.func.isRequired,
  canvasRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]).isRequired,
  drawType: PropTypes.oneOf(['free', 'arrow']),
};

SignaturePad.defaultProps = {
  drawType: 'free',
};

export default React.memo(SignaturePad);
